export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const SET_SESSION_PERMISSION = 'SET_SESSION_PERMISSION';
export const LOAD_SESSION_PERMISSION = 'LOAD_SESSION_PERMISSION';

export const COUPONS_LIST_REQUEST = 'COUPONS_LIST_REQUEST';
export const UPDATE_COUPONS_LIST = 'UPDATE_COUPONS_LIST';
export const CHANGE_COUPONS_FILTER = 'CHANGE_COUPONS_FILTER';
export const SHOW_COUPON_EDITOR_MODAL = 'SHOW_COUPON_EDITOR_MODAL';
export const CHANGE_COUPON_EDITOR_VALUES = 'CHANGE_COUPON_EDITOR_VALUES';
export const CHANGE_COUPON_STATUS = 'CHANGE_COUPON_STATUS';
export const SET_COUPON_EDITOR_DIRTY = 'SET_COUPON_EDITOR_DIRTY';
export const SHOW_COUPON_EDITOR_ERROR_MESSAGE =
  'SHOW_COUPON_EDITOR_ERROR_MESSAGE';
export const SET_COUPON_EDITOR_ERROR_MESSAGE =
  'SET_COUPON_EDITOR_ERROR_MESSAGE';
export const SET_CURRENT_COUPON_EDITOR_ERROR_MESSAGE =
  'SET_CURRENT_COUPON_EDITOR_ERROR_MESSAGE';
export const SET_COUPON_EDITOR_LOADING = 'SET_COUPON_EDITOR_LOADING';
export const SHOW_COUPON_TOGGLE_CONFIRMATION =
  'SHOW_COUPON_TOGGLE_CONFIRMATION';
export const RESET_EDITOR_MODAL = 'RESET_EDITOR_MODAL';
export const SET_COUPON_TOGGLE_LOADING = 'SET_COUPON_TOGGLE_LOADING';
export const SHOW_COUPON_DETAILS_MODAL = 'SHOW_COUPON_DETAILS_MODAL';
export const SHOW_COUPON_DETAILS_ROUTINE = 'SHOW_COUPON_DETAILS_ROUTINE';
export const SET_COUPON_DETAILS_LOADING = 'SET_COUPON_DETAILS_LOADING';
export const SET_COUPON_DETAILS_VALUES = 'SET_COUPON_DETAILS_VALUES';
export const SHOW_COUPON_DETAILS_ERROR_MESSAGE =
  'SHOW_COUPON_DETAILS_ERROR_MESSAGE';
export const SET_COUPON_DETAILS_LOGS = 'SET_COUPON_DETAILS_LOGS';
export const SET_COUPON_DETAILS_LOGS_LOADING =
  'SET_COUPON_DETAILS_LOGS_LOADING';
export const CHANGE_COUPON_DETAILS_LOGS_PAGE =
  'CHANGE_COUPON_DETAILS_LOGS_PAGE';
export const SET_COUPON_ASSIGN_MERCHANTS_MODAL_SHOWN =
  'SET_COUPON_ASSIGN_MERCHANTS_MODAL_SHOWN';
export const SET_COUPON_BUSINESS_ID_VALIDATION_RESULT =
  'SET_COUPON_BUSINESS_ID_VALIDATION_RESULT';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';

export const SHOW_TOAST = 'SHOW_TOAST';

export const LOAD_KYB_BUSINESSES_LIST = 'LOAD_KYB_BUSINESSES_LIST';
export const SET_KYB_LIST_IS_LOADING = 'SET_KYB_LIST_IS_LOADING';
export const SET_KYB_BUSINESSES_LIST = 'SET_KYB_BUSINESSES_LIST';
export const SET_KYB_LIST_FILTERS = 'SET_KYB_LIST_FILTERS';
export const SET_KYB_DETAIL_MODAL_SHOWN = 'SET_KYB_DETAIL_MODAL_SHOWN';
export const LOAD_KYB_BUSINESS_DETAIL = 'LOAD_KYB_BUSINESS_DETAIL';
// export const SET_KYB_BUSINESS_DETAIL_IS_LOADING =
//   'SET_KYB_BUSINESS_DETAIL_IS_LOADING';
export const SET_KYB_DETAIL_BUSINESS_DETAILS =
  'SET_KYB_DETAIL_BUSINESS_DETAILS';
export const SET_KYB_DETAIL_ERROR_MESSAGES = 'SET_KYB_DETAIL_ERROR_MESSAGES';
export const APPEND_KYB_DETAIL_ERROR_MESSAGES =
  'APPEND_KYB_DETAIL_ERROR_MESSAGES';
export const SET_KYB_BUSINESS_DETAIL_LOADING_STATE =
  'SET_KYB_BUSINESS_DETAIL_LOADING_STATE';
export const SET_KYB_DETAIL_KTP_DETAILS = 'SET_KYB_DETAIL_KTP_DETAILS';
export const SET_KYB_DETAIL_BANK_ACCOUNT = 'SET_KYB_DETAIL_BANK_ACCOUNT';
export const SET_KYB_APPROVE_CONFIRM_MODAL_SHOWN =
  'SET_KYB_APPROVE_CONFIRM_MODAL_SHOWN';
export const SET_KYB_APPROVE_CONFIRM_MODAL_LOADING =
  'SET_KYB_APPROVE_CONFIRM_MODAL_LOADING';
export const DO_APPROVE_KYB = 'DO_APPROVE_KYB';
export const DO_REJECT_KYB = 'DO_REJECT_KYB';
export const SET_KYB_APPROVAL_LOGS = 'SET_KYB_APPROVAL_LOGS';
export const SET_KYB_REJECT_CONFIRM_MODAL_SHOWN =
  'SET_KYB_REJECT_CONFIRM_MODAL_SHOWN';
export const SET_KYB_REJECT_CONFIRM_MODAL_LOADING =
  'SET_KYB_REJECT_CONFIRM_MODAL_LOADING';
export const SET_KYB_EDIT_BANK_ACCOUNT_MODAL_SHOWN =
  'SET_KYB_EDIT_BANK_ACCOUNT_MODAL_SHOWN';
export const SET_KYB_EDIT_BANK_ACCOUNT_MODAL_LOADING =
  'SET_KYB_EDIT_BANK_ACCOUNT_MODAL_LOADING';
export const SUBMIT_KYB_EDIT_BANK_ACCOUNT = 'SUBMIT_KYB_EDIT_BANK_ACCOUNT';
export const SET_KYB_REVIEW_DETAILS_MODAL_SHOWN =
  'SET_KYB_REVIEW_DETAILS_MODAL_SHOWN';
export const SET_KYB_REVIEW_DETAILS_MODAL_LOADING =
  'SET_KYB_REVIEW_DETAILS_MODAL_LOADING';
export const DO_SET_KYB_STATUS_PENDING = 'DO_SET_KYB_STATUS_PENDING';
export const SET_KYB_EDIT_KTP_MODAL_SHOWN = 'SET_KYB_EDIT_KTP_MODAL_SHOWN';
export const SET_KYB_EDIT_KTP_MODAL_LOADING = 'SET_KYB_EDIT_KTP_MODAL_LOADING';
export const SUBMIT_KYB_EDIT_KTP = 'SUBMIT_KYB_EDIT_KTP';

export const SET_GLOBAL_BANK_LIST = 'SET_GLOBAL_BANK_LIST';
export const LOAD_GLOBAL_BANK_LIST = 'LOAD_GLOBAL_BANK_LIST';

export const SET_NPWP_BUSINESS_LIST_IS_LOADING =
  'SET_NPWP_BUSINESS_LIST_IS_LOADING';
export const SET_NPWP_BUSINESS_LIST = 'SET_NPWP_BUSINESS_LIST';
export const LOAD_NPWP_BUSINESS_LIST = 'LOAD_NPWP_BUSINESS_LIST';
export const SET_NPWP_LIST_FILTERS = 'SET_NPWP_LIST_FILTERS';
export const SET_NPWP_DETAIL_MODAL_SHOWN = 'SET_NPWP_DETAIL_MODAL_SHOWN';
export const LOAD_NPWP_BUSINESS_DETAIL = 'LOAD_NPWP_BUSINESS_DETAIL';
export const SET_NPWP_DETAIL_ERROR_MESSAGES = 'SET_NPWP_DETAIL_ERROR_MESSAGES';
export const APPEND_NPWP_DETAIL_ERROR_MESSAGES =
  'APPEND_NPWP_DETAIL_ERROR_MESSAGES';
export const SET_NPWP_DETAIL_LOADING_STATES = 'SET_NPWP_DETAIL_LOADING_STATES';
export const SET_NPWP_DETAIL_BUSINESS_DETAILS =
  'SET_NPWP_DETAIL_BUSINESS_DETAILS';
export const SET_NPWP_DETAIL_NPWP_DETAILS = 'SET_NPWP_DETAIL_NPWP_DETAILS';
export const SET_NPWP_DETAIL_APPROVAL_LOGS = 'SET_NPWP_DETAIL_APPROVAL_LOGS';
export const SET_NPWP_APPROVE_MODAL_SHOWN = 'SET_NPWP_APPROVE_MODAL_SHOWN';
export const SET_NPWP_APPROVE_MODAL_LOADING = 'SET_NPWP_APPROVE_MODAL_LOADING';
export const DO_APPROVE_NPWP = 'DO_APPROVE_NPWP';
export const SET_NPWP_REJECT_MODAL_SHOWN = 'SET_NPWP_REJECT_MODAL_SHOWN';
export const SET_NPWP_REJECT_MODAL_LOADING = 'SET_NPWP_REJECT_MODAL_LOADING';
export const DO_REJECT_NPWP = 'DO_REJECT_NPWP';
export const SET_NPWP_REVIEW_DETAILS_MODAL_SHOWN =
  'SET_NPWP_REVIEW_DETAILS_MODAL_SHOWN';
export const SET_NPWP_REVIEW_DETAILS_MODAL_LOADING =
  ' SET_NPWP_REVIEW_DETAILS_MODAL_LOADING';
export const DO_SET_NPWP_STATUS_PENDING = 'DO_SET_NPWP_STATUS_PENDING';
export const SET_NPWP_EDIT_MODAL_SHOWN = 'SET_NPWP_EDIT_MODAL_SHOWN';
export const SET_NPWP_EDIT_MODAL_LOADING = 'SET_NPWP_EDIT_MODAL_LOADING';
export const SUBMIT_EDIT_NPWP = 'SUBMIT_EDIT_NPWP';

export const LOAD_MOKA_CONFIG_LIST = 'LOAD_MOKA_CONFIG_LIST';
export const SET_MOKA_CONFIG_LIST = 'SET_MOKA_CONFIG_LIST';
export const SUBMIT_MOKA_CONFIG_EDIT_FORM = 'SUBMIT_MOKA_CONFIG_EDIT_FORM';
export const LOAD_MOKA_CONFIG_LOGS_LIST = 'LOAD_MOKA_CONFIG_LOGS_LIST';
export const SET_MOKA_CONFIG_LOGS_LIST = 'SET_MOKA_CONFIG_LOGS_LIST';

export const DO_FORCE_ACTIVATE_PAYMENT = 'DO_FORCE_ACTIVATE_PAYMENT';
export const SET_FORCE_ACTIVATION_RESULT = 'SET_FORCE_ACTIVATION_RESULT';

export const GET_USER_BY_PHONE = 'GET_USER_BY_PHONE';
export const DO_RESET_PHONE_NUMBER = 'DO_RESET_PHONE_NUMBER';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';

export const BULK_OUTLET_UPDATE_SET_IS_PROCESSING =
  'BULK_OUTLET_UPDATE_SET_IS_PROCESSING';
export const BULK_OUTLET_UPDATE_INITIALIZE_PROCESS_STATE =
  'BULK_OUTLET_UPDATE_INITIALIZE_PROCESS_STATE';
export const BULK_OUTLET_UPDATE_SET_PROCESSED_COUNT =
  'BULK_OUTLET_UPDATE_SET_PROCESSED_COUNT';
export const DO_BULK_OUTLET_UPDATE = 'DO_BULK_OUTLET_UPDATE';
export const BULK_OUTLET_UPDATE_PREPEND_OUTLET_ERROR =
  'BULK_OUTLET_UPDATE_PREPEND_OUTLET_ERROR';
export const BULK_OUTLET_UPDATE_SET_PROCESS_STATUS =
  'BULK_OUTLET_UPDATE_SET_PROCESS_STATUS';
export const BULK_OUTLET_UPDATE_SET_CURRENT_OUTLET_ID =
  'BULK_OUTLET_UPDATE_SET_CURRENT_OUTLET_ID';
export const BULK_OUTLET_UPDATE_ABORT_PROCESS =
  'BULK_OUTLET_UPDATE_ABORT_PROCESS';
export const BULK_OUTLET_UPDATE_SHOW_CONFIRM_PROCESS_MODAL =
  'BULK_OUTLET_UPDATE_SHOW_CONFIRM_PROCESS_MODAL';
export const BULK_OUTLET_UPDATE_CONFIRM_PROCESS_RESPOND =
  'BULK_OUTLET_UPDATE_CONFIRM_PROCESS_RESPOND';
export const BULK_OUTLET_SET_TOKEN = 'BULK_OUTLET_SET_TOKEN';
export const BULK_OUTLET_DO_SHOW_LOG = 'BULK_OUTLET_DO_SHOW_LOG';
export const BULK_OUTLET_LOG_CHANGE_PAGE = 'BULK_OUTLET_LOG_CHANGE_PAGE';
export const BULK_OUTLET_LOG_SET_SHOWN = 'BULK_OUTLET_LOG_SET_SHOWN';
export const BULK_OUTLET_LOG_SET_DATA = 'BULK_OUTLET_LOG_SET_DATA';
export const BULK_OUTLET_LOG_SET_IS_LOADING = 'BULK_OUTLET_LOG_SET_IS_LOADING';
export const BULK_OUTLET_LOG_SET_ERRORS = 'BULK_OUTLET_LOG_SET_ERRORS';
export const BULK_OUTLET_SET_GLOBAL_ERROR = 'BULK_OUTLET_SET_GLOBAL_ERROR';

export const OPEN_ADD_NEW_USER_MODAL = 'OPEN_ADD_NEW_USER_MODAL';
export const CLOSE_ADD_NEW_USER_MODAL = 'CLOSE_ADD_NEW_USER_MODAL';
export const GET_ALL_ROLES = 'GET_ALL_ROLES';
export const GET_ALL_ROLES_SUCCESS = 'GET_ALL_ROLES_SUCCESS';
export const SET_CHECK_FIELD = 'SET_CHECK_FIELD';
export const CREATE_NEW_INTERNAL_USER = 'CREATE_NEW_INTERNAL_USER';
export const SET_CREATING_USER_STATE = 'SET_CREATING_USER_STATE';
export const SET_CREATED_USER_STATE = 'SET_CREATED_USER_STATE';
export const GET_ALL_INTERNAL_USERS = 'GET_ALL_INTERNAL_USERS';
export const GET_ALL_INTERNAL_USERS_SUCCESS = 'GET_ALL_INTERNAL_USERS_SUCCESS';
export const GET_ACCESS_LOGS = 'GET_ACCESS_LOGS';
export const GET_ACCESS_LOGS_SUCCESS = 'GET_ACCESS_LOGS_SUCESS';
export const GETTING_ACCESS_LOGS = 'GETTING_ACCESS_LOGS';
export const OPEN_EDIT_INTERNAL_USER_MODAL = 'OPEN_EDIT_INTERNAL_USER_MODAL';
export const CLOSE_EDIT_INTERNAL_USER_MODAL = 'CLOSE_EDIT_INTERNAL_USER_MODAL';
export const UPDATE_INTERNAL_USER = 'UPDATE_INTERNAL_USER';
export const UPDATING_INTERNAL_USER = 'UPDATING_INTERNAL_USER';
export const SET_CHECK_FIELD_GIVEN_ROLES = 'SET_CHECK_FIELD_GIVEN_ROLES';
export const OPEN_DELETE_INTERNAL_USER_MODAL =
  'OPEN_DELETE_INTERNAL_USER_MODAL';
export const CLOSE_DELETE_INTERNAL_USER_MODAL =
  'CLOSE_DELETE_INTERNAL_USER_MODAL';
export const DELETING_INTERNAL_USER = 'DELETING_INTERNAL_USER';
export const DELETE_INTERNAL_USER = 'DELETE_INTERNAL_USER';

export const GET_USER_MAPPING = 'GET_USER_MAPPING';
export const GET_USER_MAPPING_SUCCESS = 'GET_USER_MAPPING_SUCCESS';
export const GETTING_USER_MAPPING = 'GETTING_USER_MAPPING';
export const SET_USER_MAPPING_PER_PAGE = 'SET_USER_MAPPING_PER_PAGE';
export const SET_USER_MAPPING_SEARCH_KEYWORD =
  'SET_USER_MAPPING_SEARCH_KEYWORD';
export const SET_ACTIVE_USER_MAPPING = 'SET_ACTIVE_USER_MAPPING';
export const OPEN_USER_MAPPING_DETAILS = 'OPEN_USER_MAPPING_DETAILS';
export const CLOSE_USER_MAPPING_DETAILS = 'CLOSE_USER_MAPPING_DETAILS';
export const OPEN_DELETE_USER_MAPPING_MODAL = 'OPEN_DELETE_USER_MAPPING_MODAL';
export const CLOSE_DELETE_USER_MAPPING_MODAL =
  'CLOSE_DELETE_USER_MAPPING_MODAL';
export const DELETE_USER_MAPPING = 'DELETE_USER_MAPPING';
export const DELETING_USER_MAPPING = 'DELETING_USER_MAPPING';
export const UPDATE_USER_MAPPING = 'UPDATE_USER_MAPPING';
export const UPDATING_USER_MAPPING = 'UPDATING_USER_MAPPING';
export const OPEN_CREATE_USER_MAPPING_MODAL = 'OPEN_CREATE_USER_MAPPING_MODAL';
export const CLOSE_CREATE_USER_MAPPING_MODAL =
  'CLOSE_CREATE_USER_MAPPING_MODAL';
export const CREATE_USER_MAPPING = 'CREATE_USER_MAPPING';
export const CREATING_USER_MAPPING = 'CREATING_USER_MAPPING';
export const OPEN_CREATE_USER_MAPPING_UPLOAD_MODAL =
  'OPEN_CREATE_USER_MAPPING_UPLOAD_MODAL';
export const CLOSE_CREATE_USER_MAPPING_UPLOAD_MODAL =
  'CLOSE_CREATE_USER_MAPPING_UPLOAD_MODAL';
export const CREATE_USER_MAPPING_UPLOAD = 'CREATE_USER_MAPPING_UPLOAD';
export const CREATING_USER_MAPPING_UPLOAD = 'CREATING_USER_MAPPING_UPLOAD';
export const OPEN_RESET_INTERNAL_USER_PASSWORD_MODAL =
  'OPEN_RESET_INTERNAL_USER_PASSWORD_MODAL';
export const CLOSE_RESET_INTERNAL_USER_PASSWORD_MODAL =
  'CLOSE_RESET_INTERNAL_USER_PASSWORD_MODAL';
export const CREATE_USER_MAPPING_UPLOAD_SELECTED_FILE =
  'CREATE_USER_MAPPING_UPLOAD_SELECTED_FILE';
export const RESETTING_INTERNAL_USER_PASSWORD =
  'RESETTING_INTERNAL_USER_PASSWORD';
export const RESET_INTERNAL_USER_PASSWORD = 'RESET_INTERNAL_USER_PASSWORD';
export const SET_INTERNAL_USER_INPUT_SEARCH = 'SET_INTERNAL_USER_INPUT_SEARCH';
export const SEARCHING_INTERNAL_USER = 'SEARCHING_INTERNAL_USER';
export const SEARCH_INTERNAL_USER = 'SEARCH_INTERNAL_USER';
export const CLEAR_INTERNAL_USER_INPUT_SEARCH =
  'CLEAR_INTERNAL_USER_INPUT_SEARCH';
export const SET_INTERNAL_USER_ROLE_SEARCH = 'SET_INTERNAL_USER_ROLE_SEARCH';
export const CHANGE_INTERNAL_USERS_TABLE_SORT_STATE =
  'CHANGE_INTERNAL_USERS_TABLE_SORT_STATE';
export const GET_ALL_BUSINESS = 'GET_ALL_BUSINESS';
export const GET_ALL_BUSINESS_SUCCESS = 'GET_ALL_BUSINESS_SUCCESS';
export const CHANGE_BUSINESS_FILTER = 'CHANGE_BUSINESS_FILTER';
export const GETTING_ALL_BUSINESS = 'GETTING_ALL_BUSINESS';
export const OPEN_BUSINESS_DETAILS = 'OPEN_BUSINESS_DETAILS';
export const CLOSE_BUSINESS_DETAILS = 'CLOSE_BUSINESS_DETAILS';
export const SET_ACTIVE_BUSINESS_DETAILS = 'SET_ACTIVE_BUSINESS_DETAILS';
export const SET_BUSINESS_MENU_ITEM = 'SET_BUSINESS_MENU_ITEM';
export const GETTING_EMPLOYEE_SLOTS_LOGS = 'GETTING_EMPLOYEES_LOGS';
export const GETTING_EMPLOYEE_SLOTS = 'GETTING_EMPLOYEES';
export const GETTING_BUSINESS_DETAILS = 'GETTING_BUSINESS_DETAILS';
export const CREATING_EMPLOYEE_SLOT = 'CREATING_EMPLOYEE_SLOTS';
export const UPDATING_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS =
  'UPDATING_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS';
export const CREATE_EMPLOYEE_SLOT = 'CREATE_EMPLOYEE_SLOT';
export const UPDATE_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS =
  'SET_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS';
export const GET_EMPLOYEE_SLOTS_SUCCESS = 'GET_EMPLOYEE_SLOT_SUCCESS';
export const GET_PURCHASED_EMPLOYEE_SLOTS_SUCCESS =
  'GET_PURCHASED_EMPLOYEE_SLOTS_SUCCESS';
export const GET_EMPLOYEE_SLOTS_LOGS_SUCCESS = 'GET_EMPLOYEE_SLOT_LOG_SUCCESS';
export const GET_BUSINESS_DETAILS_SUCCESS = 'GET_BUSINESS_DETAILS_SUCCESS';
export const GET_EMPLOYEE_SLOTS = 'GET_EMPLOYEE_SLOTS';
export const GET_EMPLOYEE_SLOTS_LOGS = 'GET_EMPLOYEE_SLOTS_LOGS';
export const GET_BUSINESS_DETAILS = 'GET_BUSINESS_DETAILS';
export const SET_EMPLOYEE_MENU_ITEM = 'SET_EMPLOYEE_MENU_ITEM';
export const SET_EMPLOYEE_SLOTS_PAGE = 'SET_EMPLOYEE_SLOTS_PAGE';
export const SET_EMPLOYEE_ACTIONS_PAGE = 'SET_EMPLOYEE_ACTIONS_PAGE';
export const SET_EMPLOYEE_LOGS_PAGE = 'SET_EMPLOYEE_LOGS_PAGE';
export const OPEN_CREATE_EMPLOYEE_SLOT_MODAL =
  'OPEN_CREATE_EMPLOYEE_SLOT_MODAL';
export const CLOSE_CREATE_EMPLOYEE_SLOT_MODAL =
  'CLOSE_CREATE_EMPLOYEE_SLOT_MODAL';
export const SET_BUSINESS_DETAIL_MENU_ITEM = 'SET_BUSINESS_DETAIL_MENU_ITEM';
export const UPDATE_BUSINESS_PACKAGE = 'SET_BUSINESS_PACKAGE';
export const UPDATING_BUSINESS_PACKAGE = 'UPDATING_BUSINESS_PACKAGE';
export const OPEN_UPDATE_RENEWAL_STATUS_MODAL =
  'OPEN_UPDATE_RENEWAL_STATUS_MODAL';
export const CLOSE_UPDATE_RENEWAL_STATUS_MODAL =
  'CLOSE_UPDATE_RENEWAL_STATUS_MODAL';
export const SET_SELECTED_UPDATE_RENEWAL_STATUS_INDEX =
  'SET_SELECTED_UPDATE_RENEWAL_STATUS_INDEX';
export const OPEN_UPDATE_BUSINESS_PACKAGE_MODAL =
  'OPEN_UPDATE_BUSINESS_PACKAGE_MODAL';
export const CLOSE_UPDATE_BUSINESS_PACKAGE_MODAL =
  'CLOSE_UPDATE_BUSINESS_PACKAGE_MODAL';
export const SET_SELECTED_BUSINESS_PACKAGE = 'SET_SELECTED_BUSINESS_PACKAGE';
export const GET_OUTLETS = 'GET_OUTLETS';
export const GET_OUTLETS_SUCCESS = 'GET_OUTLETS_SUCCESS';
export const LOADING_OUTLETS = 'LOADING_OUTLETS';
export const ADD_OUTLET_SLOT = 'ADD_OUTLET_SLOT';
export const GET_DEVICE_LOGS = 'GET_DEVICE_LOGS';
export const GET_DEVICE_LOGS_SUCCESS = 'GET_DEVICE_LOGS_SUCCESS';
export const GET_BILLING_HISTORY = 'GET_BILLING_HISTORY';
export const GET_BILLING_HISTORY_SUCCESS = 'GET_BILLING_HISTORY_SUCCESS';
export const UPDATE_OUTLET_SUBSCRIPTIONS = 'UPDATE_OUTLET_SUBSCRIPTIONS';
export const GET_FEATURE_SUBSCRIPTIONS = 'GET_FEATURE_SUBSCRIPTIONS';
export const GET_FEATURE_SUBSCRIPTIONS_SUCCESS =
  'GET_FEATURE_SUBSCRIPTIONS_SUCCESS';
export const ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET =
  'ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET';
export const GET_OUTLET_SLOTS = 'GET_OUTLET_SLOTS';
export const GET_OUTLET_SLOTS_SUCCESS = 'GET_OUTLET_SLOTS_SUCCESS';
export const GET_GOBIZ_LINKING = 'GET_OUTLET_GOBIZ_LINKING';
export const GETTING_GOBIZ_LINKING = 'GETTING_GOBIZ_LINKING';
export const GET_GOBIZ_LINKING_SUCCESS = 'GET_GOBIZ_LINKING_SUCCESS';
export const SET_LINKING_MENU_ITEM = 'SET_LINKING_MENU_ITEM';
export const UPDATE_OUTLETS_SLOTS = 'UPDATE_OUTLETS_SLOTS';
export const UPDATE_OUTLET_SUBSCRIPTIONS_UI = 'UPDATE_OUTLET_SUBSCRIPTIONS_UI';

export const GET_OUTLET_LOGS = 'GET_OUTLET_LOGS';
export const LOADING_OUTLET_LOGS = 'LOADING_OUTLET_LOGS';
export const GET_OUTLET_LOGS_SUCCESS = 'GET_OUTLET_LOGS_SUCCESS';

export const UPLOAD_DISCOUNT_BLACKLIST = 'UPLOAD_DISCOUNT_BLACKLIST';
export const DOWNLOAD_DISCOUNT_BLACKLIST = 'DOWNLOAD_DISCOUNT_BLACKLIST';
export const SET_DOWNLOADING_DISCOUNT_BLACKLIST =
  'SET_DOWNLOADING_DISCOUNT_BLACKLIST';
export const SET_UPLOADING_DISCOUNT_BLACKLIST =
  'SET_UPLOADING_DISCOUNT_BLACKLIST';
export const FETCH_DISCOUNT_SETTINGS = 'FETCH_DISCOUNT_SETTINGS';
export const UPDATE_DISCOUNT_SETTINGS = 'UPDATE_DISCOUNT_SETTINGS';
export const UPDATE_DISCOUNT_BOTTOM_PRICE = 'UPDATE_DISCOUNT_BOTTOM_PRICE';
export const SET_FETCH_DISCOUNT_SETTINGS = 'SET_FETCH_DISCOUNT_SETTINGS';
export const SET_UPDATE_DISCOUNT_SETTINGS = 'SET_UPDATE_DISCOUNT_SETTINGS';
export const SET_UPDATE_DISCOUNT_BOTTOM_PRICE =
  'SET_UPDATE_DISCOUNT_BOTTOM_PRICE';
export const DOWNLOAD_DISCOUNT_SCHEME = 'DOWNLOAD_DISCOUNT_SCHEME';

// DELETE BUSINESS
export const BULK_DELETE_BUSINESS_SET_IS_PROCESSING =
  'BULK_DELETE_BUSINESS_SET_IS_PROCESSING';
export const BULK_DELETE_BUSINESS_INITIALIZE_PROCESS_STATE =
  'BULK_DELETE_BUSINESS_INITIALIZE_PROCESS_STATE';
export const BULK_DELETE_BUSINESS_SET_PROCESSED_COUNT =
  'BULK_DELETE_BUSINESS_SET_PROCESSED_COUNT';
export const DO_BULK_DELETE_BUSINESS = 'DO_BULK_DELETE_BUSINESS';
export const BULK_DELETE_BUSINESS_PREPEND_BUSINESS_ERROR =
  'BULK_DELETE_BUSINESS_PREPEND_BUSINESS_ERROR';
export const BULK_DELETE_BUSINESS_SET_PROCESS_STATUS =
  'BULK_DELETE_BUSINESS_SET_PROCESS_STATUS';
export const BULK_DELETE_BUSINESS_SET_CURRENT_BUSINESS_ID =
  'BULK_DELETE_BUSINESS_SET_CURRENT_BUSINESS_ID';
export const BULK_DELETE_BUSINESS_ABORT_PROCESS =
  'BULK_DELETE_BUSINESS_ABORT_PROCESS';
export const BULK_DELETE_BUSINESS_SHOW_CONFIRM_PROCESS_MODAL =
  'BULK_DELETE_BUSINESS_SHOW_CONFIRM_PROCESS_MODAL';
export const BULK_DELETE_BUSINESS_CONFIRM_PROCESS_RESPOND =
  'BULK_DELETE_BUSINESS_CONFIRM_PROCESS_RESPOND';
export const BULK_DELETE_BUSINESS_SET_GLOBAL_ERROR =
  'BULK_DELETE_BUSINESS_SET_GLOBAL_ERROR';
export const BULK_DELETE_BUSINESS_DO_SHOW_LOG =
  'BULK_DELETE_BUSINESS_DO_SHOW_LOG';
export const BULK_DELETE_BUSINESS_LOG_CHANGE_PAGE =
  'BULK_DELETE_BUSINESS_LOG_CHANGE_PAGE';
export const BULK_DELETE_BUSINESS_LOG_SET_SHOWN =
  'BULK_DELETE_BUSINESS_LOG_SET_SHOWN';
export const BULK_DELETE_BUSINESS_LOG_SET_DATA =
  'BULK_DELETE_BUSINESS_LOG_SET_DATA';
export const BULK_DELETE_BUSINESS_LOG_SET_IS_LOADING =
  'BULK_DELETE_BUSINESS_LOG_SET_IS_LOADING';
export const BULK_DELETE_BUSINESS_LOG_SET_ERRORS =
  'BULK_DELETE_BUSINESS_LOG_SET_ERRORS';

export const GETTING_RECURRING_PAYMENTS_DETAILS =
  'GETTING_RECURRING_PAYMENTS_DETAILS';
export const GET_RECURRING_PAYMENTS_DETAILS_SUCCESS =
  'GET_RECURRING_PAYMENTS_DETAILS_SUCCESS';
export const GET_RECURRING_PAYMENTS_DETAILS = 'GET_RECURRING_PAYMENTS_DETAILS';
export const SHOW_CANCEL_RECURRING_PAYMENT_CONFIRMATION =
  'SHOW_CANCEL_RECURRING_PAYMENT_CONFIRMATION';
export const CLOSE_CANCEL_RECURRING_PAYMENT_CONFIRMATION =
  'CLOSE_CANCEL_RECURRING_PAYMENT_CONFIRMATION';
export const CANCEL_RECURRING_PAYMENT = 'CANCEL_RECURRING_PAYMENT';
export const CANCELLING_RECURRING_PAYMENT = 'CANCELLING_RECURRING_PAYMENT';
export const GET_RECURRING_PAYMENT_HISTORY = 'GET_RECURRING_PAYMENT_HISTORY';
export const GET_RECURRING_PAYMENT_HISTORY_SUCCESS =
  'GET_RECURRING_PAYMENT_HISTORY_SUCCESS';
export const GET_RECURRING_PAYMENT_TRANSACTIONS =
  'GET_RECURRING_PAYMENT_TRANSACTIONS';
export const GET_RECURRING_PAYMENT_TRANSACTIONS_SUCCESS =
  'GET_RECURRING_PAYMENT_TRANSACTIONS_SUCCESS';

export const CHANGE_USER_EMAIL = 'CHANGE_USER_EMAIL';
export const CHANGE_USER_EMAIL_SUCCESS = 'CHANGE_USER_EMAIL_SUCCESS';
export const CHANGE_USER_EMAIL_FAILURE = 'CHANGE_USER_EMAIL_FAILURE';
export const RESET_CHANGE_USER_EMAIL_STATE = 'RESET_CHANGE_USER_EMAIL_STATE';
export const SET_CHANGE_USER_EMAIL_LOADING = 'SET_CHANGE_USER_EMAIL_LOADING';

export const CHANGE_USER_EMAIL_DO_SHOW_LOG = 'CHANGE_USER_EMAIL_DO_SHOW_LOG';
export const CHANGE_USER_EMAIL_LOG_CHANGE_PAGE =
  'CHANGE_USER_EMAIL_LOG_CHANGE_PAGE';
export const CHANGE_USER_EMAIL_LOG_SET_SHOWN =
  'CHANGE_USER_EMAIL_LOG_SET_SHOWN';
export const CHANGE_USER_EMAIL_LOG_SET_DATA = 'CHANGE_USER_EMAIL_LOG_SET_DATA';
export const CHANGE_USER_EMAIL_LOG_SET_IS_LOADING =
  'CHANGE_USER_EMAIL_LOG_SET_IS_LOADING';
export const CHANGE_USER_EMAIL_LOG_SET_ERRORS =
  'CHANGE_USER_EMAIL_LOG_SET_ERRORS';
